import { createIcon } from "@chakra-ui/react";

/**
 * Used for the heat waves subcategory
 * @reference [FontAwesome Icon](https://fontawesome.com/icons/sun-haze?s=solid&f=classic)
 */
const SunHaze = createIcon({
  displayName: "SunHaze",
  viewBox: "0 0 640 512",
  path: (
    <path
      d="M425.5 1.2c5 2.1 8.6 6.6 9.6 11.9L455 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L510.9 256H448c0-70.7-57.3-128-128-128s-128 57.3-128 128h-62.9l-62.3-90.3c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L185 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L320 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM320 160c53 0 96 43 96 96H224c0-53 43-96 96-96zm296 128c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h112zm-208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h320zm144 88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h528zM64 488c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24h320c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24z"
      fill="currentColor"
    />
  ),
});

export default SunHaze;
